var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3406_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.296875 11.1004C2.49833 12.2558 4.7955 13.4652 6.56973 14.401L12.7912 11.1004C10.5385 14.4078 8.66154 17.1612 6.56973 20.2085C4.47419 17.1679 2.15994 13.8128 0.296875 11.1004ZM0.536155 10.1881L6.57653 7.00267L12.5383 10.1648L6.57993 13.3537L0.536155 10.1881ZM6.56973 5.9821L0.296875 9.24563L6.54236 0.208496L12.7912 9.26587L6.56973 5.9821Z",
    fill: "#3AB83A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56936 14.401L12.791 11.1004C10.5382 14.4078 6.56936 20.2085 6.56936 20.2085V14.401ZM6.57616 7.00267L12.538 10.1648L6.57956 13.3537L6.57616 7.00267ZM6.56936 5.98234L6.54199 0.208496L12.791 9.26587L6.56936 5.98234Z",
    fill: "#0B8311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.536133 10.1872L6.57683 10.6772L12.5386 10.167L6.57991 13.3562L0.536133 10.1872Z",
    fill: "#0B8311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57715 10.6772L12.539 10.167L6.58055 13.3562L6.57715 10.6772Z",
    fill: "#146714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3406_2255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.913,
    height: 20,
    fill: "white",
    transform: "translate(0.0439453 0.208496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.4507708d37031ac296f7a0ef1be5abc3.svg";
export { ForwardRef as ReactComponent };